<template>
    <chief-pilot-log />   
</template>

<script>
import ChiefPilotLog from '@/components/ChiefPilotLog';

export default {
    components: {
        ChiefPilotLog,
    }
}
</script>
